(function() {
    'use strict';
    angular.module('portingstatus', [ 'ngSanitize', 'mnp.config'
    ]);
})();
